<ng-template #loading>Loading...</ng-template>

<por-consumer-portal-admin *axLazyElement="url; module: true; loadingTemplate: loading" [config]="config" (errorOutput)="handleOutPutError($event)"></por-consumer-portal-admin>
